// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list___Oc53","ul":"List_ul__IVSPj","ol":"List_ol__P6ErB"};